import { useQuery } from "@apollo/client";
import { BaseTable, IBaseTableProps } from "@sede-x/shell-ds-react-framework";
import { getPaginationRowModel } from "@tanstack/react-table";
import { loader } from "graphql.macro";
import { useState } from "react";
import { ApolloErrorViewer } from "shared/components/ApolloErrorViewer";
import LoadingPanel from "shared/components/LoadingPanel";
import { GqlResponse, TAlertsOfMovementAtRevision } from "ticketing/ticketing.types";

type Response = GqlResponse<TAlertsOfMovementAtRevision[], "alertsOfMovementAtRevision">;
const GET_ALERT_REVISIONS_OF_MOVEMENT = loader(
  "../../ticketing-graphql/alertsOfMovementAtRevision.graphql"
);

type DescriptionCellProps = {
  row: {
    original: TAlertsOfMovementAtRevision;
  };
};

const DescriptionCell = ({ row }: DescriptionCellProps) => {
  // Safely access the 'desc' property
  const description = row?.original?.desc || "";

  return <td title={description}>{description}</td>;
};

type RevisionsMovementAlertsProps = {
  movementId: string;
  revisionNumber: string;
};

const columns: IBaseTableProps<TAlertsOfMovementAtRevision>["columns"] = [
  {
    header: "Category",
    accessorKey: "category",
    size: 140
  },
  {
    header: "Code",
    accessorKey: "code",
    size: 140
  },
  {
    header: "Description",
    accessorKey: "desc",
    size: 300,
    cell: DescriptionCell
  }
];

const RevisionsMovementAlerts = ({
  movementId,
  revisionNumber
}: RevisionsMovementAlertsProps) => {
  const { loading, error } = useQuery<Response>(GET_ALERT_REVISIONS_OF_MOVEMENT, {
    fetchPolicy: "no-cache",
    variables: { movementId, revisionNumber },
    onCompleted: data => setAlerts(data.alertsOfMovementAtRevision)
  });
  const [alerts, setAlerts] = useState<TAlertsOfMovementAtRevision[]>([]);

  return (
    <>
      {loading && <LoadingPanel />}
      {error && <ApolloErrorViewer error={error} />}
      <BaseTable
        tableOptions={{
          defaultColumn: {
            minSize: 100,
            maxSize: 400
          },
          enableColumnResizing: true,
          columnResizeMode: "onChange",
          getPaginationRowModel: getPaginationRowModel()
        }}
        data={alerts}
        columns={columns}
        style={{ width: "100%", tableLayout: "fixed" }}
      />
    </>
  );
};

export default RevisionsMovementAlerts;
